import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=5f7cf6ca&scoped=true&"
import script from "./projectlist.js?vue&type=script&lang=js&"
export * from "./projectlist.js?vue&type=script&lang=js&"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=5f7cf6ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7cf6ca",
  null
  
)

export default component.exports